module.exports = __webpack_public_path__ + "static/media/img_1.652c181a.png";